import * as React from "react";
import { type RouteProps } from "react-router";
import { InjectRouteParams } from "../../Common/Routing/InjectRouteParams";
import { PermissionRoute } from "../../Common/Routing/PermissionRoute";

const PriceLists = React.lazy(() => import("./PriceLists"));
const PriceListEdit = React.lazy(() => import("./PriceListEdit"));
const PriceListView = React.lazy(() => import("./PriceListView"));

export default function PriceListIndex(): Array<React.ReactElement<RouteProps>> {
    return [
        <PermissionRoute
            permissions={[ "see_pricelists" ]}
            title="Price Lists | Shopfront"
            path="/pricelists"
            key="pricelists"
            element={<PriceLists />}
        />,
        <PermissionRoute
            permissions={[ "see_pricelists" ]}
            title="View Price List | Shopfront"
            path="/pricelists/:id"
            key="pricelist"
            element={<InjectRouteParams route={PriceListView} />}
        />,
        <PermissionRoute
            permissions={[ "edit_pricelists" ]}
            title="Edit Price List | Shopfront"
            path="/pricelists/:id/edit"
            key="pricelist-edit"
            element={<InjectRouteParams route={PriceListEdit} />}
        />,
    ];
}
